import { useNavigate } from "react-router-dom";
import FooterPrestataire from "../../components/FooterPrestataire";
import HeaderPrestataire from "../../components/HeaderPrestataire";
import MultiStep from "../../components/multiStep";
import { useEffect } from "react";
import TopHeader from "../../components/TopHeader";
import { getMyEtablissement } from "../../store/slices/etablissementSlice";
import { useDispatch } from "react-redux";

const LayoutPresta=(props)=>{
  const dispatch=useDispatch()
  // console.log({props})
    useEffect(() => {
      dispatch(getMyEtablissement());
    }, []);
    const navigate=useNavigate()
    const initializeSteps = () => {
      // console.log("Running initializeSteps");
      const existingSteps = localStorage.getItem("stepsStatus");
      // console.log("Existing stepsStatus:", existingSteps);
    
      if (!existingSteps) {
        // console.log("Initializing stepsStatus in localStorage");
        const initialSteps = {
          1: "notStarted",
          2: "notStarted",
          3: "notStarted",
          4: "notStarted",
          5: "notStarted",
          6: "notStarted",
        };
        localStorage.setItem("stepsStatus", JSON.stringify(initialSteps));
      } else {
        // console.log("stepsStatus already exists in localStorage");
      }
    };
    useEffect(() => {
      // console.log("Component mounted");
      initializeSteps();
    }, []);
    const passStep = (step) => {
        const stepsStatus = JSON.parse(localStorage.getItem('stepsStatus'));
        if (stepsStatus[step] === 'notStarted') {
          stepsStatus[step] = 'passed'; // Update step status to 'passed'
          localStorage.setItem('stepsStatus', JSON.stringify(stepsStatus));
        }
        navigate(props?.nextStep);
      };
     const steps=[
        {
          path: "/establishmentInfo",
          label: "Informations d’établissement",
          step: 1,
          
        },
        { path: "/type-activite", label: "Type d’activité", step: 2 },
        {
          path: "/ouverture",
          label: "Jours et horaires d’ouverture",
          step: 3,
        },
        { path: "/photos", label: "Photos", step: 4 },
        { path: "/Services", label: "Catégories et prestations", step: 5 },
        { path: "/equipe", label: "Équipe", step: 6 },
      ]
    return (
        <>
           <TopHeader btn={props?.btn} />
          <MultiStep
            steps={steps}
            currentStep={props?.currentStep}
          />
          <div className="col-lg-12 col-xs-12 container  mx-auto bg-auth">{props?.children}</div>
      
          <FooterPrestataire
            handleSubmit={props.handleSubmit}
            nameButton="Étape suivante"
            btnSecondary={"Passer l’étape"}
            actionSecondary={() => {
            passStep(props?.currentStep) ;
            }}
             // Conditionally show 'linkRoute' and 'linkName' only if currentStep > 1
            linkRoute={props.currentStep > 1 ? steps[props.currentStep - 2].path : null}
            linkName={props.currentStep > 1 ? "Étape précédente" : null}
            isSubmitting={props?.disabled}
        />
        </>
      );
}
export default LayoutPresta